import { memo } from "react";
import { images } from "../../../constants/images";
import styles from "./validation.module.scss";
import CircularProgress from "@mui/material/CircularProgress";

const Validation = ({ }) => {

    return (
        <div className={styles.validation}>
            <CircularProgress color="inherit" className={styles.processingIcon} />
            <p className={styles.title}>Un momento…</p>
            <p className={styles.subTitle}>Estamos creando tu cuenta</p>
        </div>
    )
}

export default memo(Validation);